/** Centralized timeout/interval constants — extracted from inline magic numbers. */

export const TIMEOUTS = {
  /** WebSocket handshake timeout before forced close */
  WS_CONNECTION_MS: 10_000,
  /** Call initiation safety timeout — reset pending state */
  CALL_PENDING_MS: 5_000,
  /** Copy-to-clipboard feedback duration */
  CLIPBOARD_FEEDBACK_MS: 2_000,
  /** Error notification auto-dismiss */
  NOTIFICATION_ERROR_MS: 5_000,
  /** Info/warning notification auto-dismiss */
  NOTIFICATION_INFO_MS: 3_000,
  /** HTTP request abort timeout */
  REQUEST_MS: 10_000,
} as const

export const RECONNECT = {
  /** Exponential backoff base (1s) */
  BASE_DELAY_MS: 1_000,
  /** Exponential backoff ceiling (30s) */
  MAX_DELAY_MS: 30_000,
} as const

/**
 * Exponential backoff + full half-jitter. Without jitter a relay restart
 * makes every browser reconnect at the same millisecond → thundering herd.
 * On 14 clients today it's harmless; at 100+ it hurts. Formula:
 *   `BASE * 2^attempt * (0.5 .. 1.0)`
 * clamped to `MAX_DELAY_MS`.
 */
export function computeBackoff(attempt: number): number {
  const raw = RECONNECT.BASE_DELAY_MS * 2 ** attempt
  const jitter = 0.5 + Math.random() * 0.5
  return Math.floor(Math.min(raw * jitter, RECONNECT.MAX_DELAY_MS))
}

export const QUERY = {
  /** React Query stale time */
  STALE_TIME_MS: 30_000,
  /** React Query retry count */
  RETRY_COUNT: 1,
} as const
